import React from 'react';
import { useFeatureConfig } from '../../../context/FeatureConfigContext';
import MarketplaceHome from '../../Marketplace/MarketplaceHome';
import NurseBottomNavigation from '../Layout/NurseBottomNavigation';

/**
 * Nurse App Marketplace Home Wrapper
 * Wraps MarketplaceHome component with Nurse App UI elements
 */
const NurseMarketplaceHome = () => {
  const { isFeatureEnabled } = useFeatureConfig();

  if (!isFeatureEnabled('marketplace')) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center pb-20">
        <div className="text-center">
          <div className="text-6xl mb-4">🛒</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Feature นี้ยังไม่เปิดใช้งาน</h2>
          <p className="text-gray-600">กรุณาติดต่อผู้ดูแลระบบ</p>
        </div>
        <NurseBottomNavigation />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <MarketplaceHome />
      <NurseBottomNavigation />
    </div>
  );
};

export default NurseMarketplaceHome;

